import { useMemo } from 'react';
import { useFetchCompanyDetailQuery } from '../../services/company.api';
import { SCOPE_TYPE } from '../../services/utils';
import { CompanyPermissionsResult } from './CompanyPermissionsInterface';
import { mapPermissionsToUIPermissions } from './mapToUIPermissions';

export function useCompanyPermissions(companyId?: string): CompanyPermissionsResult {
  const { data: company, isLoading } = useFetchCompanyDetailQuery(
    {
      scope: SCOPE_TYPE.COMPANY,
      id: companyId!,
    },
    {
      skip: !companyId || companyId.toUpperCase() === 'ALL',
    },
  );

  // By memoizing the permissions with the company as a dependency
  // we will only re-calculate the permissions when the company changes.
  const permissions = useMemo(() => {
    if (!company) {
      return mapPermissionsToUIPermissions([]);
    }

    return mapPermissionsToUIPermissions(company.userPermissions);
  }, [company]);

  return { ...permissions, isPermissionsLoading: isLoading };
}
